import { Dimensions, Modal, View } from 'react-native';
import { GroupAlertForm } from './groupAlertForm';
import { themedStyleSheet } from '../../../themes/themedStyleSheet';

type GroupAlertModalProps = {
  visible: boolean;
  onClose: () => void;
  groupId: string;
};

export const GroupAlertModal = ({
  visible,
  onClose,
  groupId,
}: GroupAlertModalProps) => {
  return (
    <Modal visible={visible} transparent={true} onRequestClose={onClose}>
      <View style={styles.background}>
        <View style={styles.modalContainer}>
          <GroupAlertForm groupId={groupId} onClose={onClose} />
        </View>
      </View>
    </Modal>
  );
};

const styles = themedStyleSheet((role) => ({
  background: {
    flex: 1,
    backgroundColor: role.backdrop,
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    width: '100%',
    maxWidth: 560,
    minHeight: 461,
    maxHeight: Dimensions.get('window').height * 0.8,
    backgroundColor: role.surfaceHover,
    borderRadius: 12,
    overflow: 'hidden',
    elevation: 10,
  },
}));
